import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import React, { Suspense } from "react";
import "./App.css";

// Lazy load screens
const HomeScreen = React.lazy(() => import("./screen/home/HomeScreen"));
const PortfolioScreen = React.lazy(() => import("./screen/portfolio/PortfolioScreen"));

function App() {
  return (
    <Router>
      <div className="App">
        <main>
          {/* <Suspense fallback={<div>Loading...</div>}> */}
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<HomeScreen />} />
              <Route path="/category/:slug" element={<PortfolioScreen />} />

              {/* Redirect unknown paths */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </main>
      </div>
    </Router>
  );
}

export default App;



// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import './App.css';

// import HomeScreen from './screen/home/HomeScreen';

// import PortfolioScreen from './screen/portfolio/PortfolioScreen';

// function App() {
//   return (
//     <Router>
//       <div className="App">
//         {/* <Navigation /> */}
//         {/* <Header/> */}
//         <main className="">
//           <Routes>
//             <Route path="/" element={<HomeScreen />} />
//              <Route path="/category/:slug" element={<PortfolioScreen />} />
//              {/*  */}
//             {/* <Route path="/weddings" element={<WeddingScreen />} />
//             <Route path="/food-lifestyle" element={<FoodLifestyleScreen />} />
//             <Route path="/brands-experience" element={<BrandsExperienceScreen />} />
//             <Route path="/corporate-events" element={<CorporateEventScreen />} /> */}
//             {/* Catch-all route - redirect any unknown path to home */}
//             <Route path="*" element={<Navigate to="/" replace />} />
//           </Routes>
//         </main>
//       </div>
//     </Router>
//   );
// }

// export default App;
